import { BoardGameSettings } from "../../../shared/components/cards-engine/models/cards-engine.model";
import { CategoryType } from "../../../shared/components/cards-engine/models/cards-engine.model";

export const BOARD_GAME_SETTINGS: BoardGameSettings = {
  boards: [
    {
      id: "board0",
      players: ["villain"],
      rows: [
        {
          id: "board0-row0",
          categories: [
            {
              id: "discard",
              categoryType: CategoryType.CARD,
              title: "DISCARD",
              rowCardContainerAnnexe: {
                id: "purge",
                title: "PURGE",
                showLength: true
              },
              displaySingleCard: true,
              actions: { zoomable: false, rotable: false, attachments: false },
              displayFrontAsDefaultSide: true,
              removeAllTokenWhenDragIn: true,
              fillSpace: false
            },
            {
              id: "deck",
              categoryType: CategoryType.CARD,
              title: "DECK",
              rowCardContainerAnnexe: null,
              displaySingleCard: true,
              actions: {
                zoomable: true,
                rotable: false,
                toggleSide: false,
                shufflable: true,
                attachments: false
              },
              displayFrontAsDefaultSide: false,
              removeAllTokenWhenDragIn: true,
              fillSpace: false,
              forcePortrait: true,
              hover: false
            },
            {
              id: "schemes",
              categoryType: CategoryType.CARD,
              title: "CREATURES", // keyforge --> "SCHEMES"
              rowCardContainerAnnexe: null,
              displaySingleCard: false,
              actions: {
                zoomable: false,
                rotable: true,
                toggleSide: false,
                tokens: true,
                attachments: true
              },
              displayFrontAsDefaultSide: true,
              removeAllTokenWhenDragIn: false,
              fillSpace: true
            }
          ]
        },
        {
          id: "board0-row1",
          categories: [
            {
              id: "counter",
              categoryType: CategoryType.COUNTER
            },
            {
              id: "villains",
              categoryType: CategoryType.CARD,
              title: "VILLAINS",
              rowCardContainerAnnexe: null,
              displaySingleCard: true,
              actions: {
                zoomable: false,
                rotable: true,
                toggleSide: false,
                tokens: true,
                attachments: false
              },
              displayFrontAsDefaultSide: true,
              removeAllTokenWhenDragIn: false,
              fillSpace: false
            },
            {
              id: "upgrades",
              categoryType: CategoryType.CARD,
              title: "UPGRADES & ARTEFACTS", // keyforge --> "UPGRADES"
              rowCardContainerAnnexe: null,
              displaySingleCard: false,
              actions: {
                zoomable: false,
                rotable: true,
                toggleSide: true,
                tokens: true,
                attachments: false
              },
              displayFrontAsDefaultSide: true,
              removeAllTokenWhenDragIn: false,
              fillSpace: true
            }
          ]
        },
        {
          id: "board0-row2",
          categories: [
            {
              id: "archives",
              categoryType: CategoryType.CARD,
              title: "ARCHIVES",
              rowCardContainerAnnexe: null,
              displaySingleCard: true,
              actions: {
                zoomable: true,
                rotable: false,
                toggleSide: false,
                shufflable: true,
                attachments: false
              },
              displayFrontAsDefaultSide: false,
              removeAllTokenWhenDragIn: true,
              fillSpace: false,
              forcePortrait: true
            },
            {
              id: "reveals",
              categoryType: CategoryType.CARD,
              title: "REVEALS",
              rowCardContainerAnnexe: null,
              displaySingleCard: false,
              actions: {
                zoomable: false,
                rotable: true,
                toggleSide: true,
                tokens: true,
                attachments: false
              },
              displayFrontAsDefaultSide: true,
              removeAllTokenWhenDragIn: false,
              fillSpace: true
            }
          ]
        }
      ]
    },
    {
      id: "board1",
      players: [], // 'player2', 'player3'
      rows: [
        {
          id: "board1-row0",
          categories: [
            {
              id: "discard",
              categoryType: CategoryType.CARD,
              title: "DISCARD",
              rowCardContainerAnnexe: {
                id: "purge",
                title: "PURGE",
                showLength: true
              },
              displaySingleCard: true,
              actions: { zoomable: false, rotable: false, attachments: false },
              displayFrontAsDefaultSide: true,
              removeAllTokenWhenDragIn: true,
              fillSpace: false
            },
            {
              id: "deck",
              categoryType: CategoryType.CARD,
              title: "DECK",
              rowCardContainerAnnexe: null,
              displaySingleCard: true,
              actions: {
                zoomable: true,
                rotable: false,
                toggleSide: false,
                shufflable: true,
                attachments: false
              },
              displayFrontAsDefaultSide: false,
              removeAllTokenWhenDragIn: true,
              fillSpace: false,
              forcePortrait: true
            },
            {
              id: "playGround",
              categoryType: CategoryType.CARD,
              title: "PLAYGROUND",
              rowCardContainerAnnexe: null,
              displaySingleCard: false,
              actions: {
                zoomable: false,
                rotable: true,
                toggleSide: false,
                tokens: true,
                attachments: true
              },
              displayFrontAsDefaultSide: true,
              removeAllTokenWhenDragIn: false,
              fillSpace: true
            }
          ]
        },
        {
          id: "board1-row1",
          categories: [
            {
              id: "player",
              categoryType: CategoryType.COUNTER
            },
            {
              id: "champion",
              categoryType: CategoryType.CARD,
              title: "CHAMPION",
              rowCardContainerAnnexe: null,
              displaySingleCard: true,
              actions: {
                zoomable: true,
                rotable: true,
                toggleSide: true,
                tokens: true,
                attachments: false
              },
              displayFrontAsDefaultSide: true,
              removeAllTokenWhenDragIn: false,
              fillSpace: false
            },
            {
              id: "hand",
              categoryType: CategoryType.CARD,
              title: "HAND",
              rowCardContainerAnnexe: null,
              displaySingleCard: false,
              actions: {
                zoomable: false,
                rotable: false,
                toggleSide: false,
                tokens: false,
                attachments: false
              },
              displayFrontAsDefaultSide: true,
              removeAllTokenWhenDragIn: true,
              fillSpace: true
            }
          ]
        }
      ]
    }
  ]
};
